module.exports = __webpack_public_path__ + "03_bob_gray.2288a71b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/03_bob_gray.png
// module id = MOfU
// module chunks = 0